import React from 'react';
import { Star } from 'lucide-react';
import { reviews } from '../data/mockData';

const Reviews = () => {
  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <h2 className="section-title section-title-light">What People Say</h2>
        
        <div className="rating-display">
          <div className="stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star 
                key={star} 
                className={star <= 4 ? "star-filled" : "star-half"} 
                fill={star <= 4 ? "white" : "none"}
              />
            ))}
          </div>
          <p className="rating-text">4.6 from 680 Google reviews</p>
        </div>

        <div className="reviews-grid">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              <p className="review-text">"{review.text}"</p>
              <p className="review-author">— {review.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
